// store/index.js
import Vue from "vue";
import Vuex from "vuex";
import avaliacaoModulo from "./avaliacaoModulo.js";
import remocaoModulo from "./remocaoModulo.js";
import storeLogin from "./storeLogin.js";
import storeServidor from "./rh/storeServidor.js";
import config from "./config/storeConfig.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    avaliacao: avaliacaoModulo,
    remocao: remocaoModulo,
    login: storeLogin,
    storeServidor: storeServidor,
    config: config,
  },
});
